import type { Catalog } from '@smarton-pbx/shared';

/** The platform console, where platform staff manage the companies (tenants). */
export const platform: Catalog = {
  // The frame.
  Tenants: 'Įmonės',
  'Default branding': 'Numatytoji išvaizda',
  Manage: 'Valdymas',
  'Platform staff': 'Platformos darbuotojai',

  // The list of companies.
  'Each tenant is a company with its own name, hostname, people and phone numbers.': 'Kiekviena įmonė turi savo pavadinimą, adresą, darbuotojus ir telefono numerius.',
  'New tenant': 'Nauja įmonė',
  'No tenants yet': 'Įmonių dar nėra',
  'Create the first one, starting with your own company.': 'Sukurkite pirmąją – pradėkite nuo savo įmonės.',
  Tenant: 'Įmonė',
  Hostname: 'Adresas',
  // A company's status (agrees with „būsena“).
  Active: 'Aktyvi',
  Suspended: 'Sustabdyta',

  // A new company.
  'The address its people open. On a server: a name whose DNS points here, e.g. phone.customer.com. On this computer: localhost, or a name ending in .localhost.':
    'Adresas, kurį atidaro įmonės darbuotojai. Serveryje: vardas, kurio DNS rodo į šį serverį, pvz., phone.customer.com. Šiame kompiuteryje: localhost arba vardas, besibaigiantis .localhost.',
  'You can change all of this later.': 'Visa tai galėsite pakeisti vėliau.',
  Company: 'Įmonė',
  'Shown to platform staff only': 'Rodoma tik platformos darbuotojams',
  'What the company’s people see': 'Pavadinimas, kurį mato įmonės darbuotojai',
  'Time zone': 'Laiko juosta',
  'For reports and opening hours': 'Ataskaitoms ir darbo laikui',
  'Look and limits': 'Išvaizda ir limitai',
  'Simultaneous calls': 'Skambučių vienu metu',
  'Across the whole company': 'Visoje įmonėje',
  'Daily minutes cap': 'Minučių per dieną limitas',
  'Calls stop for the day after this': 'Pasiekus šį limitą, skambučiai tą dieną sustabdomi',
  'Create tenant': 'Sukurti įmonę',

  // A company's page.
  'Created the tenant': 'Sukūrė įmonę',
  'Changed settings or branding': 'Pakeitė nustatymus ar išvaizdą',
  'Suspended the tenant': 'Sustabdė įmonę',
  'Reactivated the tenant': 'Vėl aktyvino įmonę',
  'Added an administrator': 'Pridėjo administratorių',
  'Uploaded an image': 'Įkėlė paveikslėlį',
  'Open site': 'Atidaryti svetainę',
  'Suspend {name}? Its people are signed out and can’t call.': 'Sustabdyti {name}? Įmonės darbuotojai bus atjungti ir negalės skambinti.',
  Suspend: 'Sustabdyti',
  Reactivate: 'Vėl aktyvinti',
  Administrators: 'Administratoriai',
  'AI tokens per month': 'DI žetonų per mėnesį',
  'They manage their own people, regions and branding.': 'Jie tvarko savo įmonės darbuotojus, regionus ir išvaizdą.',
  'Add administrator': 'Pridėti administratorių',
  'No administrator yet. Add one so the company can set itself up.': 'Administratoriaus dar nėra. Pridėkite jį, kad įmonė galėtų viską susitvarkyti.',
  '{n} active administrators. For privacy, the console doesn’t list a tenant’s people.': {
    one: '{n} aktyvus administratorius. Dėl privatumo konsolė nerodo įmonės darbuotojų.',
    few: '{n} aktyvūs administratoriai. Dėl privatumo konsolė nerodo įmonės darbuotojų.',
    other: '{n} aktyvių administratorių. Dėl privatumo konsolė nerodo įmonės darbuotojų.',
  },
  Usage: 'Naudojimas',
  'No usage yet': 'Naudojimo duomenų dar nėra',
  'Call minutes, recordings, transcription and AI use appear here by month.': 'Čia pagal mėnesius rodomos skambučių minutės, įrašai, transkribavimas ir DI naudojimas.',
  Month: 'Mėnuo',
  Recordings: 'Įrašai',
  'AI tokens': 'DI žetonai',
  'Platform staff activity': 'Platformos darbuotojų veiksmai',
  'They set a password, then set up an authenticator app at first sign-in.': 'Jis nusistatys slaptažodį, o pirmą kartą prisijungdamas – autentifikavimo programėlę.',
  'Call reviews pause when they are used up': 'Išnaudojus žetonus, skambučių vertinimai sustabdomi',
  'Save settings': 'Išsaugoti nustatymus',
  'Send {name} this invite link.': 'Šią kvietimo nuorodą nusiųskite asmeniui {name}.',
  Extension: 'Vidinis numeris',
  'Create invite link': 'Sukurti kvietimo nuorodą',

  // Default branding.
  Icon: 'Piktograma',
  'Default logo': 'Numatytasis logotipas',
  'Default icon': 'Numatytoji piktograma',
  'Wide, on a transparent background. PNG, SVG or WebP, up to 512 KB.': 'Platus, permatomame fone. PNG, SVG arba WebP, iki 512 KB.',
  'Square, for browser tabs and app icons. PNG or ICO.': 'Kvadratinė, naršyklės skirtukams ir programėlių piktogramoms. PNG arba ICO.',
  'Shown for every company that hasn’t uploaded its own logo or icon: on its site, its installable app, notifications and the phone app. A company’s own upload replaces it.':
    'Rodoma kiekvienai įmonei, kuri neįkėlė savo logotipo ar piktogramos: jos svetainėje, įdiegiamoje programoje, pranešimuose ir telefono programėlėje. Įmonės įkeltas paveikslėlis ją pakeičia.',
  'Companies you sell to under their own brand see this until they upload theirs.':
    'Įmonės, kurioms parduodate paslaugą su jų pačių prekės ženklu, mato šią išvaizdą, kol neįkelia savosios.',
};
